import './App.css';
import Home from "./Components/HomeComponent";
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <div className="App">
      <Home/>
    </div>
  );
}

export default App;
